export const WEB_PLUS_SHIPPING_THRESHOLD = 999.99;
